import React, { useState } from "react";
import { Toaster, toast } from "sonner";

// Styles
import "./Login.scss";

//Components
import CardBack from "../../components/atoms/CardBack/CardBack";
import Input from "../../components/atoms/Input/Input";
import Button from "../../components/atoms/Button/Button";
import InputPassword from "../../components/atoms/InputPassword/InputPassword";

//Assets
import MovilImage from "../../assets/icons/icono_login.png";
import IconUsername from "../../assets/icons/icono_perfil_login.png";
import IconPassword from "../../assets/icons/icono_password-login.png";
import ValidationMessage from "../../components/atoms/ValidationMessage/ValidationMessage";
import { validateData } from "../../utiles/ValidateEntries";
import { authenticateUser } from "../../services/login";
import { useAuthStore } from "../../zustand/ZustandContext";

const Login = () => {
    const [credentials, setCredentials] = useState({
        email: "",
        password: "",
    });

    const handleChangeDatas = (e) => {
        const { name, value } = e.currentTarget;
        setCredentials((prevent) => ({
            ...prevent,
            [name]: value,
        }));

        setEmptyField((prev) => ({
            ...prev,
            [name]: false,
        }));
    };

    const [emptyField, setEmptyField] = useState({});
    const login = useAuthStore((state) => state.login);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { status, emptyFields } = validateData(credentials);

        // Guardar los campos vacíos en el estado
        setEmptyField(emptyFields);

        if (!status) {
            console.error("Por favor, completa todos los campos requeridos.");
            return;
        }

        const toast_id = toast("Procesando...");

        const response = await authenticateUser(credentials);

        if (response.success && response.requestCode === 201) {
            toast.success("¡Bienvenido!", {
                description: "Has iniciado sesión correctamente.",
                position: "top-right",
                duration: 5000,
                icon: "🎉",
                id: toast_id,
            });

            login();
        } else {
            // Mostrar toast de error
            toast.error("¡Ups...!", {
                description:
                    response.message ||
                    "Error al iniciar sesión. Inténtalo más tarde.",
                position: "top-right",
                duration: 5000,
                icon: "😞",
                id: toast_id,
            });
        }
    };

    return (
        <CardBack className="LoginView">
            <div className="container-form">
                <div className="cnt-header">
                    <img src={MovilImage} alt="" className="movil-image" />
                    <h3>Iniciar sesion en APP Restaurant</h3>
                </div>
                <form className="form_" onSubmit={handleSubmit}>
                    <div className="cnt-inputs">
                        <div className="cnt-user">
                            <ValidationMessage
                                show={emptyField.email}
                                errorClassName="no-margin"
                            >
                                <div className="cnt-inpt-img">
                                    <Input
                                        type="email"
                                        name="email"
                                        className="input-username"
                                        placeholder="Correo electrónico"
                                        onChange={handleChangeDatas}
                                        show={emptyField.email}
                                    />
                                    <img
                                        src={IconUsername}
                                        alt=""
                                        className="icons-form"
                                    />
                                </div>
                            </ValidationMessage>
                        </div>
                        <div className="cnt-password">
                            <ValidationMessage
                                show={emptyField.password}
                                errorClassName="no-margin"
                            >
                                <div className="cnt-pass-img">
                                    <InputPassword
                                        name="password"
                                        className="input-pass"
                                        placeholder="Contraseña"
                                        onChange={handleChangeDatas}
                                        show={emptyField.password}
                                    />
                                    <img
                                        src={IconPassword}
                                        alt=""
                                        className="icons-form"
                                    />
                                </div>
                            </ValidationMessage>
                            {/* <div className="cnt-nav">
                                <NavLink
                                    to={"recover-password"}
                                    className={"forgot-pass"}
                                >
                                    <span>¿Olvidaste tu contraseña?</span>
                                </NavLink>
                            </div> */}
                        </div>
                    </div>
                    <Button text="Ingresar" className="degrad" type="submit" />
                </form>
                {/* <div className="container-footer">
                    <NavLink className={"block-nav"}>
                        <span className="s-clic">
                            ¿Quieres probar la aplicación?
                        </span>
                        <span className="tooltip_">Haz clic aquí</span>
                    </NavLink>
                </div> */}
            </div>
            <Toaster />
        </CardBack>
    );
};

export default Login;
